import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DailyReport from './DailyReport';
import { Link } from 'react-router-dom';
import ENDPOINT from '../../context/EndPoint';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import Localbase from 'localbase';
import { useDispatch } from 'react-redux';
import { useActionsContext } from '../../context/ActionsContext';

const DailyReports = () => {
  const dispatch = useDispatch();
  const db = new Localbase('db');
  const [reports, setReports] = useState(null);
  const { user } = useContext(AuthContext);
    const { rowsPerPage } = useActionsContext(); 
  

  const fetchReports = async () => {
    try {
      dispatch({ type: 'LOADING' });
      const data = new FormData();
      data.append('session', user.SessionId);
      data.append('limit', rowsPerPage);

      const response = await axios.post(ENDPOINT + 'admin-get-daily-reports.php', data);

      if (response.data.status === 'success') {
        dispatch({ type: 'DONE_LOADING' });
        const reportsData = response.data.reports || response.data.data || [];
        setReports(reportsData);
        db.collection('paths').add({ data: reportsData }, 'reports');
        console.log('API response:', response.data);
      } else {
        dispatch({ type: 'ERROR', payload: 'Error Occurred Getting Daily Reports' });
      }
    } catch (error) {
      console.error('Error fetching reports:', error);
      dispatch({ type: 'ERROR', payload: 'Error Occurred Getting Daily Reports' });
    }
  };

  const getofflinereports = () => {
    db.collection('paths')
      .doc('reports')
      .get()
      .then((doc) => {
        if (doc && doc.data) {
          setReports(doc.data);
          console.log('Offline reports loaded:', doc.data);
        } else {
          console.log('No offline reports found');
          setReports([]);
        }
      })
      .catch((error) => {
        console.error('Error loading offline reports:', error);
        setReports([]);
      });
  };

  useEffect(() => {
    const loadReports = async () => {
      try {
        await fetchReports();
      } catch (error) {
        console.error('Failed to fetch reports, loading offline data');
        getofflinereports();
      }
    };

    loadReports();
  }, [rowsPerPage]);

  return (
    <div>
      <div className="container-fluid d-flex justify-content-between">
        <h2>Daily Reports</h2>
        <Link to="/add-daily-report" className="btn btn-primary">
          Add Report
        </Link>
      </div>
      <hr />
      <div className="container-fluid sm-p-15 d-flex flex-wrap">
        {reports && reports.length > 0 ? (
          reports.map((report) => <DailyReport key={report.id} report={report} />)
        ) : (
          <p>No reports available</p>
        )}
      </div>
    </div>
  );
};

export default DailyReports;